import { Injectable } from '@angular/core';
import { ObligationForm } from '../../data/system/obligation';
import * as ExcelJS from 'exceljs';
import { NumberService } from './number.service';
import { env } from '../../../app.constant';
import { SessionService } from '../../mock/system/session.service';
import { ObligationStatusUtilService } from './obligationStatusUtil.service';
import { SysUtilService } from './sysUtil.service';

@Injectable()
export class ORSReportUtilService {

    private numberFormat = "#,##0.00";
    private cellTotalPlusPagination = 51;
    private cellTotalPlusPaginationAdj = 0;
    private fontStyle = {
        header: { name: 'Times New Roman', size: 10, bold: true },
        content: { name: 'Times New Roman', size: 10 }
    };
    private columns = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J'];
    private borderStyle: any = {
        thin: { style: 'thin' },
        full: {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        },
        topBottom: {
            top: { style: 'thin' },
            bottom: { style: 'thin' }
        },
        leftRight: {
            left: { style: 'thin' },
            right: { style: 'thin' }
        },
        topLeft: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        topRight: {
            top: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomLeft: {
            bottom: { style: 'thin' },
            left: { style: 'thin' }
        },
        bottomRight: {
            bottom: { style: 'thin' },
            right: { style: 'thin' }
        }
    };
    private particularsTotalAmountValue: Array<string> = [];
    private particularsMaxContentPerPage: number = 10;
    private statusMaxContentPerPage: number = 8;

    public orsData: ObligationForm | any = undefined;
    public signatories: any = {};
    private obligationStatus: Array<any> = [];

    constructor(
        private numberService: NumberService,
        private sessionService: SessionService,
        private orsStatService: ObligationStatusUtilService,
        private sysUtil: SysUtilService
    ) {
        this.cellTotalPlusPaginationAdj = 0;
        let year = new Date().getFullYear();
        this.setSignatories(year);
    }

    public getORSDetails(ors: ObligationForm | any, date: any | undefined = undefined, hideStatus: boolean = false, minimize: boolean = false) {
        console.log(`getORSDetails()->ors`, ors);
        let content = [];

        if (minimize) {
            ors = this.minimizeObligationStatus(ors);
        }

        this.getObligationStatus(ors, date);

        if (hideStatus) {
            // this.obligationStatus = this.obligationStatus.filter((st: any) => st.type == "ors");
            this.obligationStatus = [];
        }

        // let status_set = new Set(this.obligationStatus.map((set: any) => set.fnd_code));
        // let status_group = [];
        // status_set.forEach((status: any) => {
        //     let selected_status_set = this.obligationStatus.filter((v: any) => v.fnd_code == status);
        //     selected_status_set.sort((a: any, b: any) => {
        //     //     return Number(a.fnd_code) - Number(b.fnd_code);
        //     // }).sort((a: any, b: any) => {
        //         return (Number(new Date(a.date)) - Number(new Date(b.date)))
        //     });
        //     // status_group.push(selected_status_set);
        //     status_group = status_group.concat(selected_status_set);
        // });

        // console.log(`getORSDetails()->status_group`, status_set);

        let collectionsA = [];
        let collectionsB = [];

        let itemData = {
            fund_code_name: `${ors.or_fund_code_name} / ${ors.or_fund_code}`,
            fund_src: ors.fund_src,
            fund_source: "",
            particulars: ors.or_particulars,

            acct_name: "",
            acct_uacs_code: "",
            fn_name: "",
            fn_amount: "",

            function_name: "",

            status: []
        };

        let fundSource = {
            '164': "PRE",
            '164-SB': "Savings",
            '164-CB': "Continuing",
        };

        let index = 0;
        ors.fund_source.forEach((fndSrc: any) => {
            itemData.fund_source = fndSrc.ofs_fund_name;
            itemData.fund_src = `${fundSource[fndSrc.ofs_fund_code]} FY ${ors.or_year}`;
            fndSrc.account.forEach((acct: any) => {
                itemData.acct_name = acct.oa_acct_name;
                itemData.acct_uacs_code = acct.oa_uacs_code;
                itemData.function_name = acct.oa_sysref_name;
                acct.function.forEach((fn: any) => {
                    itemData.fn_name = fn.of_fund_name;
                    itemData.fn_amount = fn.of_amount;
                    itemData.status = fn.status;
                    if (index == 0) {
                        collectionsA.push(JSON.parse(JSON.stringify(itemData)));
                    } else {
                        collectionsB.push(JSON.parse(JSON.stringify(itemData)));
                    }
                });
            });
            index++;
        });
        console.log(`getORSDetails()->collectionsA`, collectionsA);
        console.log(`getORSDetails()->collectionsB`, collectionsB);

        let colASize = collectionsA.length;
        let colBSize = collectionsB.length;
        let sum = colASize + colBSize;

        let pageData = {
            fund_code_name: `${ors.or_fund_code_name} / ${ors.or_fund_code}`,
            fund_src: ors.fund_src,
            fund_source: [],
            particulars: ors.or_particulars,
            account: [],
            function: [],
            status: this.obligationStatus,
            total: 0,
            status_total: { obligation: 0, payable: 0, payment: 0 }
        };

        let statusColumnSize = this.obligationStatus.length - this.statusMaxContentPerPage;
        if (this.cellTotalPlusPaginationAdj < statusColumnSize) {
            this.cellTotalPlusPaginationAdj = statusColumnSize;
        }

        // const ors_status = this.obligationStatus.sort((a: any, b: any) => (new Date(a.date) as any) - (new Date(b.date) as any));
        const ors_status = this.obligationStatus;

        if (sum <= this.particularsMaxContentPerPage) {
            // single page
            // let orsStatus = this.orsStatService.setNotYetDue(ors_status);
            let orsStatus = ors_status;
            let collections = collectionsA.concat(collectionsB);

            pageData.status = orsStatus.slice(0, this.statusMaxContentPerPage);
            content.push(this.getPageData(pageData, collections));

            let additionalOrsStatus = orsStatus.slice(this.statusMaxContentPerPage);
            const totalPage = Math.ceil(additionalOrsStatus.length / (this.particularsMaxContentPerPage + 1));
            for (let i = 0; i < totalPage; i++) {
                pageData.status = additionalOrsStatus.slice(i * (this.particularsMaxContentPerPage + 1), (i + 1) * (this.particularsMaxContentPerPage + 1));
                let prevCollections = content[content.length - 1] || undefined;
                content.push(this.getPageData(pageData, [], prevCollections));
            }
        }

        if (sum > this.particularsMaxContentPerPage) {

            let combinedCollections = collectionsA.concat(collectionsB);
            let combinedTotalPage = Math.ceil(combinedCollections.length / this.particularsMaxContentPerPage);
            for (let i = 0; i < combinedTotalPage; i++) {
                let collections = combinedCollections.slice(i * this.particularsMaxContentPerPage, ((i + 1) * this.particularsMaxContentPerPage));
                let orsStatus = ors_status; // use all statuses for combined
                let prevCollections = content[content.length - 1] || undefined;
                pageData.status = orsStatus.slice(i * this.statusMaxContentPerPage, (i + 1) * this.statusMaxContentPerPage);
                content.push(this.getPageData(pageData, collections, prevCollections));
                // additional paging, status is greater than the collections
                let additionalOrsStatus = orsStatus.slice((i + 1) * this.statusMaxContentPerPage);
                if (additionalOrsStatus.length > 0 && ((i + 1) === combinedTotalPage)) {
                    let additionalPage = Math.ceil(additionalOrsStatus.length / (this.particularsMaxContentPerPage + 1));
                    for (let stIndex = 0; stIndex < additionalPage; stIndex++) {
                        pageData.status = additionalOrsStatus.slice(stIndex * (this.particularsMaxContentPerPage + 1), (stIndex + 1) * (this.particularsMaxContentPerPage + 1));
                        let prevCollections = content[content.length - 1] || undefined;
                        content.push(this.getPageData(pageData, [], prevCollections));
                    }
                }
            }

            /*
            // changed by Yuri 2024-06-10
            // TUITION FEES
            let colATotalPage = Math.ceil(collectionsA.length / this.particularsMaxContentPerPage);
            for (let i = 0; i < colATotalPage; i++) {
                let collections = collectionsA.slice(i * this.particularsMaxContentPerPage, ((i + 1) * this.particularsMaxContentPerPage));
                // let orsStatus = this.orsStatService.setNotYetDue(ors_status.filter((st: any) => st.fnd_code == '164010000'));
                let orsStatus = ors_status.filter((st: any) => st.fnd_code == '164010000');
                let prevCollections = content[content.length - 1] || undefined;
                pageData.status = orsStatus.slice(i * this.statusMaxContentPerPage, (i + 1) * this.statusMaxContentPerPage);
                content.push(this.getPageData(pageData, collections, prevCollections));
                // additional paging, status is greater that the collections 
                let additionalOrsStatus = orsStatus.slice((i + 1) * this.statusMaxContentPerPage);
                if (additionalOrsStatus.length > 0 && ((i + 1) === colATotalPage)) {
                    let additionalPage = Math.ceil(additionalOrsStatus.length / (this.particularsMaxContentPerPage + 1));
                    for (let stIndex = 0; stIndex < additionalPage; stIndex++) {
                        pageData.status = additionalOrsStatus.slice(stIndex * (this.particularsMaxContentPerPage + 1), (stIndex + 1) * (this.particularsMaxContentPerPage + 1));
                        let prevCollections = content[content.length - 1] || undefined;
                        content.push(this.getPageData(pageData, [], prevCollections));
                    }
                }
            }
            // FIDUCIARY / MISCELLANEOUS FEES
            let colBTotalPage = Math.ceil(collectionsB.length / this.particularsMaxContentPerPage);
            for (let i = 0; i < colBTotalPage; i++) {
                let collections = collectionsB.slice(i * this.particularsMaxContentPerPage, ((i + 1) * this.particularsMaxContentPerPage));
                // let orsStatus = this.orsStatService.setNotYetDue(ors_status.filter((st: any) => st.fnd_code == '164020000'));
                let orsStatus = ors_status.filter((st: any) => st.fnd_code == '164020000');
                let prevCollections = content[content.length - 1] || undefined;
                pageData.status = orsStatus.slice(i * this.statusMaxContentPerPage, (i + 1) * this.statusMaxContentPerPage);
                content.push(this.getPageData(pageData, collections, prevCollections));
                // additional paging, status is greater than the collections
                let additionalOrsStatus = orsStatus.slice((i + 1) * this.statusMaxContentPerPage);
                if (additionalOrsStatus.length > 0 && ((i + 1) === colBTotalPage)) {
                    let additionalPage = Math.ceil(additionalOrsStatus.length / (this.particularsMaxContentPerPage + 1));
                    for (let stIndex = 0; stIndex < additionalPage; stIndex++) {
                        pageData.status = additionalOrsStatus.slice(stIndex * (this.particularsMaxContentPerPage + 1), (stIndex + 1) * (this.particularsMaxContentPerPage + 1));
                        let prevCollections = content[content.length - 1] || undefined;
                        content.push(this.getPageData(pageData, [], prevCollections));
                    }
                }
            }
            // end of changed by Yuri 2024-06-10
            */
        }
        console.log(`getORSDetails()->content`, content);

        return content;

        // ors.fund_source.forEach((fndSrc: any) => {  // fund_source
        //     let pageData = {
        //         fund_code_name: `${ors.or_fund_code_name} / ${ors.or_fund_code}`,
        //         fund_src: ors.fund_src,
        //         fund_source: [fndSrc.ofs_fund_name],
        //         particulars: ors.or_particulars,
        //         account: [],
        //         function: [],
        //         status: []
        //     };
        //     let fndSrcContent = [];
        //     fndSrc.account.sort((a: any, b: any) => Number(a.oa_uacs_code) - Number(b.oa_uacs_code)).sort((a: any, b: any) => Number(a.oa_sysref_code) - Number(b.oa_sysref_code));
        //     fndSrc.account.forEach((acct: any) => { // account
        //         let acctDetails = {
        //             acct_name: acct.oa_acct_name,
        //             uacs_code: acct.oa_uacs_code,
        //             functions: []
        //         };
        //         acct.function.forEach((funct: any) => { // function
        //             acctDetails.functions.push({ name: funct.of_fund_name, amount: funct.of_amount });
        //             funct.of_fund_sysref_code = acct.oa_sysref_code;
        //             fndSrcContent.push(funct);
        //         });
        //         pageData.account.push(acctDetails);
        //         pageData.function.push(acct.oa_sysref_name);
        //     });
        //     pageData.function = pageData.function.filter((item: any, pos: number) => pageData.function.indexOf(item) == pos);
        //     pageData.status = status_group[content.length];
        //     let statusColumnSize = status_group[content.length].length - this.statusMaxContentPerPage;
        //     if (this.cellTotalPlusPaginationAdj < statusColumnSize) {
        //         this.cellTotalPlusPaginationAdj = statusColumnSize;
        //     }
        //     let page = Math.ceil(fndSrcContent.length / this.particularsMaxContentPerPage);
        //     if (page > 1) {
        //         for (let i = 0; i < page; i++) {
        //             let subPageData = JSON.parse(JSON.stringify(pageData));
        //             let currentArrayIndex = this.particularsMaxContentPerPage * i;
        //             subPageData.account = fndSrcContent.filter((fsc: any, fscIndex: number) => (fscIndex >= currentArrayIndex) && (fscIndex < (currentArrayIndex + this.particularsMaxContentPerPage)));
        //             content.push(subPageData);
        //         }
        //     } else {
        //         content.push(pageData);
        //     }

        //     fndSrcContent = null;
        // });

        // console.log(`getORSDetails()->cellTotalPlusPaginationAdj`, this.cellTotalPlusPaginationAdj);

        // console.log(`getORSDetails()->content`, content);

        // return content;
    }

    async generateORSListSummaryExcel(data: Array<any>, year: string = "", options: any = { fileName: "ORS_List", sheetName: "ORS" }) {
        const wb = new ExcelJS.Workbook();
        wb.addWorksheet(options.sheetName);

        const ws = wb.getWorksheet(options.sheetName);

        ws.columns = [
            { header: "DATE", key: "or_date", width: 12 },
            { header: "ORS No.", key: "or_number", width: 17 },
            { header: "PAYEE", key: "payee", width: 12 },
            { header: "PARTICULARS", key: "or_particulars", width: 24 },
            { header: "EXPENSE BY OBJECT OF EXPENDITURES", key: "obj_expenditure", width: 12 },
            { header: "FUND SOURCE", key: "fund_source", width: 12 },
            { header: "CATEGORY OF FUND SOURCE", key: "category_fund", width: 12 },
            { header: "FUND SOURCE REFERENCE", key: "fund_src_ref", width: 15 },
            { header: "EXPENSE CLASS", key: "expense_class", width: 12 },
            { header: "DEPARTMENT", key: "department", width: 12 },
            { header: "ACCOUNT CODE", key: "account_code", width: 12 },
            { header: "ACCOUNT NAME", key: "account_name", width: 17 },
            { header: "1ST QUARTER ORS Original", key: "orig_ors_q1", width: 12, style: { numFmt: this.numberFormat } },
            { header: "1ST QUARTER ORS", key: "ors_q1", width: 12 },
            { header: "Adjustment in ORS (DIFFERENCE OF ORS AMOUNT & P.O.)", key: "diff_q1", width: 12 },
            { header: `AMOUNT PAID (JANUARY ${year})`, key: "amt_paid_jan", width: 12 },
            { header: "BALANCE", key: "balance_jan", width: 12 },
            { header: `AMOUNT PAID (FEBRUARY ${year})`, key: "amt_paid_feb", width: 12 },
            { header: "BALANCE", key: "balance_feb", width: 12 },
            { header: `AMOUNT PAID (MARCH ${year})`, key: "amt_paid_mar", width: 12 },
            { header: "BALANCE", key: "balance_mar", width: 12 },
            { header: "TOTAL AMOUNT PAID 1ST QUARTER", key: "total_amt_paid_q1", width: 12 },
            { header: "2ND QUARTER ORS Original", key: "orig_ors_q2", width: 12 },
            { header: "2ND QUARTER ORS", key: "ors_q2", width: 12 },
            { header: "Adjustment in ORS (DIFFERENCE OF ORS AMOUNT & P.O.)", key: "diff_q2", width: 12 },
            { header: `AMOUNT PAID (APRIL ${year})`, key: "amt_paid_apr", width: 12 },
            { header: "BALANCE", key: "balance_apr", width: 12 },
            { header: `AMOUNT PAID (MAY ${year})`, key: "amt_paid_may", width: 12 },
            { header: "BALANCE", key: "balance_may", width: 12 },
            { header: `AMOUNT PAID (JUNE ${year})`, key: "amt_paid_jun", width: 12 },
            { header: "BALANCE", key: "balance_jun", width: 12 },
            { header: "TOTAL AMOUNT PAID 2ND QUARTER", key: "total_amt_paid_q2", width: 12 },
            { header: "3RD QUARTER ORS Original", key: "orig_ors_q3", width: 12 },
            { header: "3RD QUARTER ORS", key: "ors_q3", width: 12 },
            { header: "Adjustment in ORS (DIFFERENCE OF ORS AMOUNT & P.O.)", key: "diff_q3", width: 12 },
            { header: `AMOUNT PAID (JULY ${year})`, key: "amt_paid_jul", width: 12 },
            { header: "BALANCE", key: "balance_jul", width: 12 },
            { header: `AMOUNT PAID (AUGUST ${year})`, key: "amt_paid_aug", width: 12 },
            { header: "BALANCE", key: "balance_aug", width: 12 },
            { header: `AMOUNT PAID (SEPTEMBER ${year})`, key: "amt_paid_sept", width: 12 },
            { header: "BALANCE", key: "balance_sept", width: 12 },
            { header: "TOTAL AMOUNT PAID 3RD QUARTER", key: "total_amt_paid_q3", width: 12 },
            { header: "4TH QUARTER ORS Original", key: "orig_ors_q4", width: 12 },
            { header: "4TH QUARTER ORS", key: "ors_q4", width: 12 },
            { header: "Adjustment in ORS (DIFFERENCE OF ORS AMOUNT & P.O.)", key: "diff_q4", width: 12 },
            { header: `AMOUNT PAID (OCTOBER ${year})`, key: "amt_paid_oct", width: 12 },
            { header: "BALANCE", key: "balance_oct", width: 12 },
            { header: `AMOUNT PAID (NOVEMBER ${year})`, key: "amt_paid_nov", width: 12 },
            { header: "BALANCE", key: "balance_nov", width: 12 },
            { header: `AMOUNT PAID (DECEMBER ${year})`, key: "amt_paid_dec", width: 12 },
            { header: "BALANCE", key: "balance_dec", width: 12 },
            { header: "TOTAL AMOUNT PAID 4TH QUARTER", key: "total_amt_paid_q4", width: 12 },
            { header: "TOTAL OBLIGATIONS", key: "total_obligations", width: 12 },
            { header: "TOTAL Disbursements", key: "total_disbursement", width: 12 },
            { header: "Due and Demandable", key: "due_demandable", width: 12 },
            { header: "Not Yet Due and Demandable", key: "not_yet_due_demandable", width: 12 }
        ];

        let cols = [
            "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
            "AA", "AB", "AC", "AD", "AE", "AF", "AG", "AH", "AI", "AJ", "AK", "AL", "AM", "AN", "AO", "AP", "AQ", "AR", "AS", "AT", "AU", "AV", "AW", "AX", "AY", "AZ",
            "BA", "BB", "BC", "BD"
        ];

        ws.getRow(1).height = 60;

        cols.forEach((col: string) => {
            let cell = ws.getCell(`${col}1`);
            cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
            cell.border = this.borderStyle.full;
            cell.font = this.fontStyle.header;
        });

        // parse int
        let numberValues = [
            "orig_ors_q1", "ors_q1", "diff_q1", "amt_paid_jan", "balance_jan", "amt_paid_feb", "balance_feb", "amt_paid_mar", "balance_mar", "total_amt_paid_q1",
            "orig_ors_q2", "ors_q2", "diff_q2", "amt_paid_apr", "balance_apr", "amt_paid_may", "balance_may", "amt_paid_jun", "balance_jun", "total_amt_paid_q2",
            "orig_ors_q3", "ors_q3", "diff_q3", "amt_paid_jul", "balance_jul", "amt_paid_aug", "balance_aug", "amt_paid_sept", "balance_sept", "total_amt_paid_q3",
            "orig_ors_q4", "ors_q4", "diff_q4", "amt_paid_oct", "balance_oct", "amt_paid_nov", "balance_nov", "amt_paid_dec", "balance_dec", "total_amt_paid_q4",
            "total_obligations", "total_disbursement", "due_demandable", "not_yet_due_demandable"
        ];

        data.forEach((dt: any, dtIndex: number) => {
            numberValues.forEach((nv: string) => dt[nv] = ((parseInt(dt[nv]) != 0) ? parseFloat(dt[nv]) : ''));
            ws.addRow(dt);
            cols.forEach((col: string, colIndex: number) => {
                let cell = ws.getCell(`${col}${dtIndex + 2}`);

                if (colIndex >= 12) {
                    cell.style = { numFmt: this.numberFormat };
                    cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'right' };
                } else {
                    cell.alignment = { wrapText: true, vertical: 'middle', horizontal: 'center' };
                }

                cell.border = this.borderStyle.full;
                cell.font = this.fontStyle.content;
            });
        });

        const arrayData = await wb.xlsx.writeBuffer();
        const blob = new Blob([arrayData], { type: "application/octet-binary" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${options.fileName}.xlsx`;
        a.click();
        a.remove();
    }

    async generateExcel(ors: ObligationForm | any, options: any = { fileName: "ORS", sheetName: "Sheet1" }, date: any | undefined = undefined, year: any | undefined) {
        this.particularsTotalAmountValue = [];
        this.orsData = ors;

        this.setSignatories(year);

        this.getFundSource();

        const wb = new ExcelJS.Workbook();
        wb.addWorksheet(options.sheetName);

        const ws = wb.getWorksheet(options.sheetName);

        const imagePath = './assets/BatStateULogo.png';

        this.sysUtil.getBase64ImageFromUrl(imagePath).then(async (result: any) => {

            ws.columns = [
                { header: "", key: "A", width: 12 },
                { header: "", key: "B", width: 12 },
                { header: "", key: "C", width: 12 },
                { header: "", key: "D", width: 12 },
                { header: "", key: "E", width: 12 },
                { header: "", key: "F", width: 12 },
                { header: "", key: "G", width: 12 },
                { header: "", key: "H", width: 12 },
                { header: "", key: "I", width: 12 },
                { header: "", key: "J", width: 12 }
            ];

            // format ors report content
            let content = this.getORSDetails(ors, date);

            let pageTotal = content.length;

            console.log(`total_content`, content);

            content.forEach((data: any, i: number) => {
                let page = i + 1;

                let imageId = wb.addImage({ base64: result, extension: 'png' });
                let rowIndex = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
                ws.addImage(imageId, { tl: { col: 0, row: rowIndex }, ext: { width: 59, height: 55 } });

                this.setDefaultPageStyles(ws, page);
                this.setHeader(ws, page);

                this.setPayeeDetails(ws, page);

                this.setParticulars(ws, page);
                this.setParticularsContent(ws, page, data, pageTotal);

                this.setAandBDetails(ws, page);
                this.setSignatureDetails(ws, page);

                this.setStatusObligation(ws, page, data);

                // paging
                let paginationRowPos = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * page;
                ws.mergeCells(`A${paginationRowPos}:J${paginationRowPos}`);
                let pagination = ws.getCell(`A${paginationRowPos}`);
                pagination.value = `PAGE ${this.numberService.zeroPad(page, 2)}/${this.numberService.zeroPad(pageTotal, 2)}`;
                pagination.font = this.fontStyle.content;
                pagination.alignment = { wrapText: true, vertical: "middle", horizontal: "right" };
            });

            const arrayData = await wb.xlsx.writeBuffer();
            const blob = new Blob([arrayData], { type: "application/octet-binary" });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `${options.fileName}.xlsx`;
            a.click();
            a.remove();

        });
    }

    private minimizeObligationStatus(ors: ObligationForm | any) {
        let o: any = ors;
        let fund_source = [];
        o.fund_source.forEach((fndSrc: any) => {
            let account = [];
            fndSrc.account.forEach((acct: any) => {
                let fnction = acct.function.reduce((carry, item) => {
                    if (carry.length === 0) {
                        carry.push({
                            of_id: "",
                            oa_id: "",
                            of_fund_code: "",
                            of_fund_sysref_code: "",
                            of_fund_name: acct.oa_sysref_name,
                            of_amount: Number(item.of_amount),
                            of_payment: Number(item.of_payment),
                            status: []
                        });
                    } else if (carry.length > 0) {
                        carry[0].of_amount += Number(item.of_amount);
                        carry[0].of_payment += Number(item.of_payment);
                    }
                    return carry;
                }, []);
                account.push({
                    aa_id: acct.aa_id,
                    function: fnction,
                    oa_acct_name: acct.oa_acct_name,
                    oa_id: acct.oa_id,
                    oa_sysref_code: acct.oa_sysref_code,
                    oa_sysref_name: acct.oa_sysref_name,
                    oa_uacs_code: acct.oa_uacs_code,
                    ofs_id: acct.ofs_id
                });
            });
            fund_source.push({
                account: account,
                ofs_fund_code: fndSrc.ofs_fund_code,
                ofs_fund_name: fndSrc.ofs_fund_name,
                ofs_fund_sysref_code: fndSrc.ofs_fund_sysref_code,
                ofs_id: fndSrc.ofs_id,
                or_id: fndSrc.or_id
            });
        });
        o.fund_source = fund_source;
        return o;
    }

    private getObligationStatus(ors: ObligationForm | any, date: any | undefined) {
        this.obligationStatus = this.orsStatService.getObligationStatus(ors, date);
        // this.obligationStatus.sort((a: any, b: any) => {
        //     return Number(a.fnd_code) - Number(b.fnd_code);
        // }).sort((a: any, b: any) => {
        //     return Number(new Date(a.date)) - Number(new Date(b.date));
        // });
        console.log(`obligationStatus `, this.obligationStatus);
    }

    private getFundSource() {
        if (this.orsData.fund_source.length === 0) {
            this.orsData.fund_src = "";
            return;
        }
        if (this.orsData.or_fund_code_name.includes("STF")) {
            // let date = new Date();
            // this.orsData.fund_src = env.fund_source_ors.STF[this.orsData.fund_source[0].ofs_fund_code.replace("164", "")].replace("{year}", date.getFullYear());
            this.orsData.fund_src = env.fund_source_ors.STF[this.orsData.fund_source[0].ofs_fund_code.replace("164", "")].replace("{year}", this.orsData.or_year);
        }
    }

    private setDefaultPageStyles(ws: ExcelJS.Worksheet, page: number = 1) {
        let startingPosition = 1;
        let index = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
        let rowPosition = startingPosition + index;

        let pageRowSize = (this.cellTotalPlusPagination - 1) + this.cellTotalPlusPaginationAdj;

        // for (let p = 0; p < page; p++) {
        for (let i = rowPosition; i <= (pageRowSize + index); i++) {
            this.columns.forEach((c: any) => {
                let pageCells = ws.getCell(`${c}${i}`);
                pageCells.font = this.fontStyle.content;
                pageCells.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
                if (c == 'A' && i == rowPosition) { pageCells.border = this.borderStyle.topLeft; }
                if (c == 'A' && ((i > rowPosition) && (i < (pageRowSize + index)))) { pageCells.border = { left: this.borderStyle.thin }; }
                if (c == 'A' && i == (pageRowSize + index)) { pageCells.border = this.borderStyle.bottomLeft; }

                if (c == 'J' && i == rowPosition) { pageCells.border = this.borderStyle.topRight; }
                if (c == 'J' && ((i > rowPosition) && (i < (pageRowSize + index)))) { pageCells.border = { right: this.borderStyle.thin }; }
                if (c == 'J' && i == (pageRowSize + index)) { pageCells.border = this.borderStyle.bottomRight; }

                if (c != 'A' && c != 'J' && i == rowPosition) { pageCells.border = { top: this.borderStyle.thin }; }
                if (c != 'A' && c != 'J' && i == (pageRowSize + index)) { pageCells.border = { bottom: this.borderStyle.thin }; }
            });
        }
        // }
    }

    private setHeader(ws: ExcelJS.Worksheet, page: number = 1) {
        let startingPosition = 1;

        let index = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
        let rowPosition = startingPosition + index;

        ws.mergeCells(`A${rowPosition}:A${rowPosition + 2}`);
        let logo = ws.getCell(`A${rowPosition}`);
        logo.border = this.borderStyle.full;

        // wb.xlsx.readFile("./assets/BatStateULogo.png")
        //   .then(function () {
        //     var imageID = wb.addImage({
        //       filename: "./assets/BatStateULogo.png",
        //       extension: 'png',
        //     });
        //     console.log("imageID", imageID);

        //     ws.addImage(imageID, {
        //       tl: { col: 0, row: 0 },
        //       ext: { width: 50, height: 50 } // currently I'm using fixed width and height.
        //     });
        // });

        // let imageId = wb.addImage({ filename: "../../../assets/BatStateULogo.png", extension: "png" });
        // ws.addImage(imageId, {
        //   tl: { col: 0, row: 0 },
        //   ext: { width: 50, height: 50 }
        // });

        ws.mergeCells(`B${rowPosition}:F${rowPosition + 2}`);
        let isoReferenceNo = ws.getCell(`B${rowPosition}`);
        isoReferenceNo.value = "Reference No. : BatSTateU-FO-BUD-01";
        isoReferenceNo.font = this.fontStyle.header;
        isoReferenceNo.border = { top: this.borderStyle.thin, bottom: this.borderStyle.thin, right: this.borderStyle.thin };
        isoReferenceNo.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };

        ws.mergeCells(`G${rowPosition}:I${rowPosition + 2}`);
        let isoEffectivity = ws.getCell(`G${rowPosition}`);
        isoEffectivity.value = "Effectivity Date: May 18, 2022";
        isoEffectivity.font = this.fontStyle.header;
        isoEffectivity.border = { top: this.borderStyle.thin, left: this.borderStyle.thin, bottom: this.borderStyle.thin, right: this.borderStyle.thin };
        isoEffectivity.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        ws.mergeCells(`J${rowPosition}:J${rowPosition + 2}`);
        let isoRevision = ws.getCell(`J${rowPosition}`);
        isoRevision.value = "Revision No. 02";
        isoRevision.font = this.fontStyle.header;
        isoRevision.border = { top: this.borderStyle.thin, left: this.borderStyle.thin, bottom: this.borderStyle.thin, right: this.borderStyle.thin };
        isoRevision.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        ws.getCell(`A${rowPosition + 3}`).border = { left: this.borderStyle.thin };
        ws.getCell(`A${rowPosition + 4}`).border = { left: this.borderStyle.thin };
        ws.getCell(`A${rowPosition + 5}`).border = { left: this.borderStyle.thin };
        ws.getCell(`A${rowPosition + 6}`).border = this.borderStyle.bottomLeft;

        let selectedCampus = env.campuses.filter((c: any) => c.value == this.orsData.or_campus);
        let campus = (selectedCampus.length > 0) ? selectedCampus[0].text : "";
        let orsFormTitle = ["OBLIGATION REQUEST AND STATUS", "Batangas State University", "The National Engineering University", campus];
        for (let i = 0; i < orsFormTitle.length; i++) {
            ws.mergeCells(`B${rowPosition + (3 + i)}:G${rowPosition + (3 + i)}`);
            let orsTitle = ws.getCell(`B${rowPosition + (3 + i)}`);
            orsTitle.value = `${orsFormTitle[i]}`;
            orsTitle.font = this.fontStyle.header;
            orsTitle.alignment = { wrapText: true, vertical: "middle", horizontal: "center" };
        }

        ws.mergeCells(`H${rowPosition + 3}:J${rowPosition + 3}`);
        let serialNo = ws.getCell(`H${rowPosition + 3}`);
        serialNo.value = `Serial No: ${this.orsData.or_number}`;
        serialNo.font = this.fontStyle.header;
        serialNo.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
        serialNo.border = { right: this.borderStyle.thin };

        ws.mergeCells(`H${rowPosition + 4}:J${rowPosition + 5}`);
        let orsDate = ws.getCell(`H${rowPosition + 4}`);
        orsDate.value = `Date: ${this.orsData.or_date}`;
        orsDate.font = this.fontStyle.header;
        orsDate.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
        orsDate.border = { right: this.borderStyle.thin };

        ws.mergeCells(`H${rowPosition + 6}:J${rowPosition + 6}`);
        let fundCluster = ws.getCell(`H${rowPosition + 6}`);
        fundCluster.value = `Fund Cluster: 164`;
        fundCluster.font = this.fontStyle.header;
        fundCluster.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
        fundCluster.border = this.borderStyle.bottomRight;
    }

    private setPayeeDetails(ws: ExcelJS.Worksheet, page: number = 1) {
        let startingPosition = 8;

        let index = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
        let rowPosition = startingPosition + index;

        let payeeLabel = ["Payee", "Office", "Address"];
        let payeeData = [
            this.orsData.payee.map((p: any) => p.op_name).join(", "),
            this.orsData.payee.map((p: any) => p.op_office).join(", "),
            this.orsData.payee.map((p: any) => p.op_address).join(", ")
        ];
        for (let i = 0; i < 3; i++) {
            let label = ws.getCell(`A${rowPosition + i}`);
            label.value = payeeLabel[i];
            label.border = this.borderStyle.full;

            ws.mergeCells(`B${rowPosition + i}:J${rowPosition + i}`);
            let payeeDetails = ws.getCell(`B${rowPosition + i}`);
            payeeDetails.value = payeeData[i];
            payeeDetails.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
            payeeDetails.border = this.borderStyle.full;
        }
    }

    private setParticulars(ws: ExcelJS.Worksheet, page: number = 1) {
        let startingPosition = 11;

        let index = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
        let rowPosition = startingPosition + index;

        ws.getRow(rowPosition).height = 40;
        let rcHeader = ws.getCell(`A${rowPosition}`);
        rcHeader.value = `Responsibility Center`;
        rcHeader.font = this.fontStyle.header;
        rcHeader.border = this.borderStyle.full;

        ws.mergeCells(`B${rowPosition}:G${rowPosition}`);
        let particularHeader = ws.getCell(`B${rowPosition}`);
        particularHeader.value = `PARTICULAR`;
        particularHeader.font = this.fontStyle.header;
        particularHeader.border = this.borderStyle.full;

        let mfoPapHeader = ws.getCell(`H${rowPosition}`);
        mfoPapHeader.value = `MFO/PAP`;
        mfoPapHeader.font = this.fontStyle.header;
        mfoPapHeader.border = this.borderStyle.full;

        let uacsHeader = ws.getCell(`I${rowPosition}`);
        uacsHeader.value = `UACS Code Expenditures`;
        uacsHeader.font = this.fontStyle.header;
        uacsHeader.border = this.borderStyle.full;

        let amountHeader = ws.getCell(`J${rowPosition}`);
        amountHeader.value = `Amount`;
        amountHeader.font = this.fontStyle.header;
        amountHeader.border = this.borderStyle.full;

        let fields = ["A", "H", "I", "J"];
        for (let i = 0; i < this.particularsMaxContentPerPage + 1; i++) {
            fields.forEach((e: any) => {
                let particulars = ws.getCell(`${e}${(rowPosition + 1) + i}`);
                particulars.value = ``;
                if (e == "J") {
                    particulars.style = { numFmt: this.numberFormat };
                    particulars.font = this.fontStyle.content;
                }
                particulars.border = this.borderStyle.leftRight;
            });
        }

        ws.mergeCells(`B${rowPosition + 1}:G${rowPosition + this.particularsMaxContentPerPage}`);
        let particularsDetail = ws.getCell(`B${rowPosition + 1}`);
        particularsDetail.value = ``;

        ws.mergeCells(`B${rowPosition + (this.particularsMaxContentPerPage + 1)}:G${rowPosition + (this.particularsMaxContentPerPage + 1)}`);
        let particularTotal = ws.getCell(`B${rowPosition + (this.particularsMaxContentPerPage + 1)}`);
        particularTotal.value = ``;
        particularTotal.border = { bottom: this.borderStyle.thin };
    }

    private setParticularsContent(ws: ExcelJS.Worksheet, page: number = 1, data: any = undefined, pageTotal: number = 0) {
        let startingPosition = 12;

        let index = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
        let rowPosition = startingPosition + index;

        let default_rc_values = [data.fund_code_name, data.fund_src, data.fund_source];

        default_rc_values.forEach((d: any, i: number) => {
            let rc_default = ws.getCell(`A${rowPosition + i}`);
            rc_default.value = d;
        });

        data.function.forEach((fData: any, fnIndx: number) => {
            let functions = ws.getCell(`A${rowPosition + (default_rc_values.length + fnIndx)}`);
            functions.value = fData;
        });

        let particulars = ws.getCell(`B${rowPosition}`);
        particulars.value = data.particulars;
        particulars.alignment = { wrapText: true, vertical: "top", horizontal: "left" };

        let indx = rowPosition;
        data.account.forEach((acct: any) => {
            acct.functions.forEach((funct: any, i: number) => {
                let fn = ws.getCell(`H${indx}`);
                fn.value = funct.name;
                if (i == 0) {
                    let act = ws.getCell(`I${indx}`);
                    act.value = `${acct.acct_name}\n${acct.uacs_code}`;
                }
                let amt = ws.getCell(`J${indx}`);
                amt.value = Number(funct.amount);
                amt.alignment = { wrapText: true, vertical: "middle", horizontal: "right" };
                indx++;
            });
        });

        let currentRow = rowPosition + this.particularsMaxContentPerPage;
        let total = ws.getCell(`B${currentRow}`);
        total.alignment = { wrapText: true, vertical: "middle", horizontal: "right" };
        total.font = this.fontStyle.header;
        total.value = (page == pageTotal) ? `Total ` : `Amount to be Forwarded `;

        let totalAmount = ws.getCell(`J${currentRow}`);
        totalAmount.alignment = { wrapText: true, vertical: "middle", horizontal: 'right' };
        totalAmount.font = this.fontStyle.header;
        totalAmount.value = { formula: `sum(J${rowPosition}:J${currentRow - 1})`, date1904: false };

        // set particulars total amount value
        if ((page == pageTotal) && (pageTotal > 1)) {
            ws.getCell(`J${currentRow}`).value = { formula: `sum(J${rowPosition}:J${currentRow - 1})+sum(${this.particularsTotalAmountValue.join(",")})`, date1904: false };
        } else {
            this.particularsTotalAmountValue.push(`J${currentRow}`);
        }
    }

    private setAandBDetails(ws: ExcelJS.Worksheet, page: number = 1) {
        let startingPosition = 28;

        let index = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
        let rowPosition = startingPosition + index;

        ws.getRow(rowPosition).height = 40;
        ws.mergeCells(`A${rowPosition}:G${rowPosition}`);
        let aDetails = ws.getCell(`A${rowPosition}`);
        aDetails.value = `A. Certified: Charges to appropriation allotment are necessary, lawful and under my direct supervision & supporting documents valid, proper and legal.`;
        aDetails.font = this.fontStyle.header;
        aDetails.border = this.borderStyle.full;
        aDetails.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };

        ws.mergeCells(`H${rowPosition}:J${rowPosition}`);
        let bDetails = ws.getCell(`H${rowPosition}`);
        bDetails.value = `B. Certified allotment available and obligated for the purpose/adjustment necessary as indicated above.`;
        bDetails.font = this.fontStyle.header;
        bDetails.border = this.borderStyle.full;
        bDetails.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
    }

    private setSignatureDetails(ws: ExcelJS.Worksheet, page: number = 1) {
        let startingPosition = 29;

        let index = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
        let rowPosition = startingPosition + index;

        let signatureLabel = ["", "Signature:", "Printed Name:", "Position", "Date:"];
        let i = 0;
        signatureLabel.forEach((lbl: string) => {
            let signLbl1 = ws.getCell(`A${rowPosition + i}`);
            signLbl1.value = `${lbl}`;
            signLbl1.font = this.fontStyle.header;
            signLbl1.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
            signLbl1.border = { left: this.borderStyle.thin };

            let signLbl2 = ws.getCell(`H${rowPosition + i}`);
            signLbl2.value = `${lbl}`;
            signLbl2.font = this.fontStyle.header;
            signLbl2.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
            signLbl2.border = { left: this.borderStyle.thin };
            if (i == signatureLabel.length - 1) {
                signLbl1.border = this.borderStyle.bottomLeft;
                signLbl2.border = this.borderStyle.bottomLeft;
            }
            i++;
        });
        ws.getCell(`B${rowPosition + (signatureLabel.length - 1)}`).border = { bottom: this.borderStyle.thin };
        ws.getCell(`C${rowPosition + (signatureLabel.length - 1)}`).border = { bottom: this.borderStyle.thin };

        let signer1 = [this.orsData.or_supervisor_fullname, this.orsData.or_supervisor_position_name, ""];
        let signatureDetails = [this.signatories.head.name, this.signatories.head.position, ""];
        i = 0;
        signatureDetails.forEach((sign: string) => {
            ws.mergeCells(`C${(rowPosition + 2) + i}:G${(rowPosition + 2) + i}`);
            let sign1 = ws.getCell(`C${(rowPosition + 2) + i}`);
            sign1.value = `${signer1[i]}`;
            sign1.font = this.fontStyle.header;

            ws.getCell(`J${rowPosition}`).border = { right: this.borderStyle.thin };
            ws.getCell(`J${rowPosition + 1}`).border = { right: this.borderStyle.thin };
            ws.mergeCells(`I${(rowPosition + 2) + i}:J${(rowPosition + 2) + i}`);
            let sign2 = ws.getCell(`I${(rowPosition + 2) + i}`);
            sign2.value = `${sign}`;
            sign2.font = this.fontStyle.header;
            sign2.border = { right: this.borderStyle.thin };
            if (i == signatureDetails.length - 1) {
                sign1.border = this.borderStyle.bottomRight;
                sign2.border = this.borderStyle.bottomRight;
            }
            i++;
        });

    }

    private setStatusObligation(ws: ExcelJS.Worksheet, page: number = 1, data: any = undefined) {
        let startingPosition = 34;

        let index = (this.cellTotalPlusPagination + this.cellTotalPlusPaginationAdj) * (page - 1);
        let rowPosition = startingPosition + index;

        // set obligation status header
        let statusLetter = ws.getCell(`A${rowPosition}`);
        statusLetter.value = `C.`;
        statusLetter.font = this.fontStyle.header;
        statusLetter.alignment = { wrapText: true, vertical: "middle", horizontal: "left" };
        statusLetter.border = this.borderStyle.bottomLeft;

        ws.mergeCells(`B${rowPosition}:J${rowPosition}`);
        let statusTitle = ws.getCell(`B${rowPosition}`);
        statusTitle.value = `Status of Obligation`;
        statusTitle.font = this.fontStyle.header;
        statusTitle.border = this.borderStyle.bottomRight;

        let refAmtRowPos = rowPosition + 1;
        ws.mergeCells(`A${refAmtRowPos}:E${refAmtRowPos}`);
        let reference = ws.getCell(`A${refAmtRowPos}`);
        reference.value = `Reference`;
        reference.font = this.fontStyle.header;
        reference.border = this.borderStyle.bottomLeft;

        ws.mergeCells(`F${refAmtRowPos}:J${refAmtRowPos}`);
        let amount = ws.getCell(`F${refAmtRowPos}`);
        amount.value = `Amount`;
        amount.font = this.fontStyle.header;
        amount.border = this.borderStyle.bottomRight;

        let statusHeadRowPos = rowPosition + 2;
        let referenceHeader = ["Date", "Particulars", "ORS/ JEV/ RC/ RADAI No."];
        let colLetter = ["A", "B", "E"];
        ws.getRow(statusHeadRowPos).height = 15;
        ws.getRow(statusHeadRowPos + 1).height = 30;
        referenceHeader.forEach((refHead: string, i: number) => {
            if (colLetter[i] == "B") {
                ws.mergeCells(`B${statusHeadRowPos}:D${statusHeadRowPos + 2}`);
            } else {
                ws.mergeCells(`${colLetter[i]}${statusHeadRowPos}:${colLetter[i]}${statusHeadRowPos + 2}`);
            }
            let refHeadTitle = ws.getCell(`${colLetter[i]}${statusHeadRowPos}`);
            refHeadTitle.value = `${refHead}`;
            refHeadTitle.font = this.fontStyle.header;
            refHeadTitle.border = this.borderStyle.full;
        });

        let amountHeader = ["Obligation", "Payable", "Payment", "Not yet Due", "Due and Demandable"];
        let colAmountLetter = ["F", "G", "H", "I", "J"];
        let colFormLetter = ["(a)", "(b)", "(c)", "(a-b)", "(b-c)"];
        let amountHeaderRowPos = statusHeadRowPos + 1;
        amountHeader.forEach((amtHead: string, i: number) => {
            if (i < 3) {
                ws.mergeCells(`${colAmountLetter[i]}${amountHeaderRowPos}:${colAmountLetter[i]}${statusHeadRowPos}`);
            }
            let amtHeadTitle = ws.getCell(`${colAmountLetter[i]}${amountHeaderRowPos}`);
            amtHeadTitle.value = `${amtHead}`;
            amtHeadTitle.font = this.fontStyle.header;
            amtHeadTitle.border = this.borderStyle.full;

            let amtFormHeadTitle = ws.getCell(`${colAmountLetter[i]}${amountHeaderRowPos + 1}`);
            amtFormHeadTitle.value = `${colFormLetter[i]}`;
            amtFormHeadTitle.font = this.fontStyle.header;
            amtFormHeadTitle.border = this.borderStyle.full;
        });

        ws.mergeCells(`I${statusHeadRowPos}:J${statusHeadRowPos}`);
        let balance = ws.getCell(`I${statusHeadRowPos}:J${statusHeadRowPos}`);
        balance.value = `Balance`;
        balance.font = this.fontStyle.header;
        balance.border = this.borderStyle.full;

        // format obligation status content;
        let statusContent = rowPosition + 5;
        let cols = ["A", "E", "F", "G", "H", "I", "J"];
        for (let i = 0; i < ((this.statusMaxContentPerPage + this.cellTotalPlusPaginationAdj) + 1); i++) {
            ws.mergeCells(`B${statusContent + i}:D${statusContent + i}`);
            cols.forEach((colsN: any, colsIndex: number) => {
                if (colsIndex >= 2) {
                    ws.getCell(`${colsN}${statusContent + i}`).style = { numFmt: this.numberFormat };
                    ws.getCell(`${colsN}${statusContent + i}`).alignment = { wrapText: true, vertical: 'middle', horizontal: 'right' };
                    ws.getCell(`${colsN}${statusContent + i}`).font = this.fontStyle.content;
                }
                if (i < (this.statusMaxContentPerPage + this.cellTotalPlusPaginationAdj)) {
                    ws.getCell(`${colsN}${statusContent + i}`).border = this.borderStyle.leftRight;
                } else {
                    ws.getCell(`${colsN}${statusContent + i}`).border = { left: this.borderStyle.thin, bottom: this.borderStyle.thin, right: this.borderStyle.thin };
                }
            });
        }

        // set obligation status content
        // this.obligationStatus.forEach((stat: any, i: number) => {
        //     if (i < 13) {

        // forwarded total
        if (data.content.length === 0) {
            ws.getCell(`F${statusContent}`).font = this.fontStyle.header;
            ws.getCell(`G${statusContent}`).font = this.fontStyle.header;
            ws.getCell(`H${statusContent}`).font = this.fontStyle.header;
            ws.getCell(`I${statusContent}`).font = this.fontStyle.header;
            ws.getCell(`J${statusContent}`).font = this.fontStyle.header;

            ws.getCell(`F${statusContent}`).value = Number(Number(data.status_total.obligation).toFixed(2));
            ws.getCell(`G${statusContent}`).value = Number(Number(data.status_total.payable).toFixed(2));
            ws.getCell(`H${statusContent}`).value = Number(Number(data.status_total.payment).toFixed(2));
            // ws.getCell(`I${statusContent}`).value = Number(Number(data.status_total.obligation - data.status_total.payable).toFixed(2));
            // ws.getCell(`J${statusContent}`).value = Number(Number(data.status_total.payable - data.status_total.payment).toFixed(2));
            ws.getCell(`I${statusContent}`).value = { formula: `F${statusContent}-G${statusContent}`, date1904: false };
            ws.getCell(`J${statusContent}`).value = { formula: `G${statusContent}-H${statusContent}`, date1904: false };
        }

        data.status.forEach((stat: any, i: number) => {
            const modIndex = (data.content.length > 0) ? i : i + 1;
            ws.getCell(`A${statusContent + modIndex}`).value = `${this.toStringDate(stat.date)}`;
            ws.getCell(`B${statusContent + modIndex}`).value = `${stat.acct_name}`;
            ws.getCell(`E${statusContent + modIndex}`).value = `${stat.remarks}`;

            ws.getCell(`F${statusContent + modIndex}`).value = Number(Number(stat.obligation).toFixed(2));
            ws.getCell(`G${statusContent + modIndex}`).value = Number(Number(stat.payable).toFixed(2));
            ws.getCell(`H${statusContent + modIndex}`).value = Number(Number(stat.payment).toFixed(2));
            ws.getCell(`I${statusContent + modIndex}`).value = Number(Number(stat.not_yet_due).toFixed(2));
            ws.getCell(`J${statusContent + modIndex}`).value = Number(Number(stat.due_and_demandable).toFixed(2));
        });
        //     }
        // });

        // set total obligation status
        let statusTotalRowPosition = statusContent + (this.statusMaxContentPerPage + this.cellTotalPlusPaginationAdj);
        let particularsTotal = ws.getCell(`B${statusTotalRowPosition}`);
        particularsTotal.font = this.fontStyle.header;
        particularsTotal.alignment = { wrapText: true, vertical: 'middle', horizontal: 'right' };

        ws.getCell(`B${statusTotalRowPosition}`).value = "TOTALS";
        cols.filter((d: string, indx: number) => indx >= 2).forEach((colLetter: string) => {
            let total = ws.getCell(`${colLetter}${statusTotalRowPosition}`);
            total.font = this.fontStyle.header;
            total.value = { formula: `sum(${colLetter}${statusContent}:${colLetter}${statusTotalRowPosition - 1})`, date1904: false };
            if (colLetter == "I") {
                total.value = { formula: `F${statusTotalRowPosition}-G${statusTotalRowPosition}`, date1904: false };
            }
            if (colLetter == "J") {
                total.value = { formula: `G${statusTotalRowPosition}-H${statusTotalRowPosition}`, date1904: false };
            }
        });

    }

    private toStringDate(date: string): string {
        const dt = new Date(date);
        return `${this.numberService.zeroPad(dt.getDate(), 2)}-${env.short_months[dt.getMonth()]}-${dt.getFullYear().toString().substring(2)}`
    }

    private getPageData(pageData: any, collections: any, prevCollections: any = undefined) {
        let fund_source = collections.map((value: any) => value.fund_source);
        pageData.fund_source = fund_source.filter((v: any, i: any) => fund_source.indexOf(v) === i);
        let acct = collections.map((v: any) => {
            return {
                acct_name: v.acct_name,
                uacs_code: v.acct_uacs_code,
                functions: collections.filter((fn: any) => fn.acct_uacs_code == v.acct_uacs_code).map((v: any) => { return { name: v.fn_name, amount: v.fn_amount, functions: v.function_name }; })
            };
        });
        pageData.account = [...new Map(acct.map((a: any) => [((acct: any) => acct.uacs_code)(a), a])).values()]
        let logFunds = [];
        pageData.content = collections.map((v: any, i: number) => {
            let content = {
                fnd_src: "",
                rc: v.function_name,
                mfo_pap: v.fn_name,
                acct_name: v.acct_name,
                acct_uacs: v.acct_uacs_code,
                amount: v.fn_amount
            };
            if (logFunds.indexOf(v.fund_src) == -1) {
                logFunds.push(v.fund_src);
                content.fnd_src = v.fund_src;
            }
            return content;
        });
        // pageData.account = acct.map((a: any) => [((acct: any) => acct.uacs_code)(a), a]);
        // let functions = collections.map((col: any) => col.function_name);
        // pageData.function = functions.filter((v: any, i: any) => functions.indexOf(v) == i);
        // pageData.function = functions;
        pageData.total = (prevCollections != undefined) ? prevCollections.total : 0;
        if (prevCollections != undefined) {
            let status_collection = prevCollections.status.map((st: any) => { return { obligation: st.obligation, payable: st.payable, payment: st.payment }; });
            pageData.status_total = {
                obligation: this.numberService.getArraySum(status_collection.map((s: any) => Number(s.obligation))) + prevCollections.status_total.obligation,
                payable: this.numberService.getArraySum(status_collection.map((s: any) => Number(s.payable))) + prevCollections.status_total.payable,
                payment: this.numberService.getArraySum(status_collection.map((s: any) => Number(s.payment))) + prevCollections.status_total.payment
            };
        }
        collections.forEach((c: any) => pageData.total += Number(c.fn_amount));
        return JSON.parse(JSON.stringify(pageData));
    }

    private setSignatories(year: any = undefined) {
        this.sessionService.getCampusSession().subscribe((campus: string | number) => {
            const signatories = env.budget_oic[year].filter((oic: any) => Number(oic.id) === Number(campus));
            if (signatories.length > 0) {
                this.signatories = signatories[0];
            }
        });
    }

}
